import { privateAxios } from "@/common/api/axios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseNegotiationsProps<T> = {
  filters?: {
    page?: number;
    search?: string;
    status?: string;
    establishment_id?: string;
  };
  mapper?: (data: any) => T,
};

export const useNegotiations = <T,>({
  filters: { search, page, status, establishment_id } = {},
  mapper = Mapper.default<T>(),
}: UseNegotiationsProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['negotiations', search, page, status, establishment_id],
    queryFn: () => {
      return privateAxios.get(`/negotiations`, {
        params: {
          search,
          page,
          'q[status_eq]': status,
          'q[establishment_company_eq]': establishment_id,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
